/** Minimal shape so callsites that access .product still compile. */
export interface IapPackageStub {
  identifier: string;
  product: { identifier: string; priceString: string; title: string };
}

/**
 * IAP stub — native IAP (RevenueCat / Capacitor) lives in the iOS-only repo.
 * This stub keeps existing callsites compiling; all methods no-op / return empty.
 */
export class IapManager {
  isReady(): boolean { return false; }
  getAvailablePackages(): IapPackageStub[] { return []; }
  async purchase(_productId: string): Promise<{ success: boolean; gems: number; error?: string }> {
    return { success: false, gems: 0, error: "IAP not available" };
  }
  async restore(): Promise<{ restoredTransactions: number }> {
    return { restoredTransactions: 0 };
  }
  isNativeIapAvailable(): boolean { return false; }
}

export const iapManager = new IapManager();
